import { useState, useEffect } from "react"

export default function useScroll() {
  const [pos, setPos] = useState({ x: 0, y: 0 })
  const browser =
    typeof window !== `undefined`
      ? window
      : {
          addEventListener: () => {},
          removeEventListener: () => {},
          scrollX: 0,
          scrollY: 0,
        }

  useEffect(() => {
    const handleScroll = () => {
      setPos({ x: browser.scrollX, y: browser.scrollY })
    }
    browser.addEventListener("scroll", handleScroll)
    return () => {
      browser.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return pos
}
